import type { ImageRef } from '../atoms/state';

import { env } from '@/constants/env';

export const IMAGE_TO_VIDEO_SAMPLE_IMAGES: ImageRef[] = [
  {
    id: 'walkthrough',
    url: `${env.API_URL}/images/default-image2video-mode_walkthrough?size=thumbnail500`,
  },
  {
    id: 'drop-furnish',
    url: `${env.API_URL}/images/default-image2video-mode_drop-furniture?size=thumbnail500`,
  },
  {
    id: 'day-and-night',
    url: `${env.API_URL}/images/default-image2video-mode_day-and-night?size=thumbnail500`,
  },
];
